export default {
    computed: {
        // Check if is article selected in concept
        isArticleSelected() {
            return this.fields.concepts.map((c) => {
                if (c.article) {
                    if (c.article.key) return true
                }

                return false
            })
        },

        // Get filters for concept articles
        lotFilter() {
            const filters = {}

            Object.keys(this.fields.concepts).forEach((key) => {
                const concept = this.fields.concepts[key]

                if (concept.article) {
                    if (concept.article.data) {
                        filters[key] = [
                            {
                                _ParentOperator: 'AND',
                                _Operator: 'AND',
                                Fields: {
                                    article: {
                                        type: 4,
                                        string: String(concept.article.key),
                                        opt: '='
                                    }
                                }
                            }
                        ]
                    }
                } else {
                    filters[key] = null
                }
            })

            return filters
        },
    },
    methods: {
        // Reset concepts
        resetConcepts(){
            this.fields.concepts = []
            this.createConcept();
        },
        // Add new concept
        createConcept() {
            this.fields.concepts.push({
                article: null,
                discount: 0,
                discount_value: 0,
                expiration_date: null,
                lot: null,
                name: '',
                price: 0,
                quantity: 1,
                iva: 0,
                iva_value: 0,
                surcharge: 0,
                surcharge_value: 0
            })
        },
        // Remove concept
        removeConcept(index) {
            this.fields.concepts.splice(index, 1)
        },
    }
}
